export default function LabelOptionsIcon({style={}}){
  let resolvedStyle = {transform: 'rotate(180deg)',...style};


  let dim = resolvedStyle.fontSize||"18"

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={dim} fill={style.color||style.fill||"#000000"} viewBox="0 -960 960 960" width={dim} style={resolvedStyle}><path d="M380-440q17 0 28.5-11.5T420-480q0-17-11.5-28.5T380-520q-17 0-28.5 11.5T340-480q0 17 11.5 28.5T380-440Zm140 0q17 0 28.5-11.5T560-480q0-17-11.5-28.5T520-520q-17 0-28.5 11.5T480-480q0 17 11.5 28.5T520-440Zm140 0q17 0 28.5-11.5T700-480q0-17-11.5-28.5T660-520q-17 0-28.5 11.5T620-480q0 17 11.5 28.5T660-440ZM360-200q-20 0-37.5-9T294-234L120-480l174-246q11-16 28.5-25t37.5-9h400q33 0 56.5 23.5T840-680v400q0 33-23.5 56.5T760-200H360Zm400-80v-400 400Zm-400 0h400v-400H360L218-480l142 200Z"/></svg>
  )
}
